module.exports = __webpack_public_path__ + "img/big.0427bbbe.jpg";